import { render, staticRenderFns } from "./workflow-approval-dialog.vue?vue&type=template&id=0edfa916&scoped=true"
import script from "./workflow-approval-dialog.vue?vue&type=script&lang=js"
export * from "./workflow-approval-dialog.vue?vue&type=script&lang=js"
import style0 from "./workflow-approval-dialog.vue?vue&type=style&index=0&id=0edfa916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edfa916",
  null
  
)

export default component.exports